import _ from "lodash";

export const splitCamelCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before capital letters
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' ');
  }

  export const capitalizeFirstLetter = (str) => {
    if (_.isEmpty(str)){
      return;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  export const camelCase = (str) => {
    // Using replace method with regEx
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index == 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

export const properCase = (string) => {
  return string.toLocaleLowerCase().split(" ").map(word => word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase()).join(" ")
}